import { useContext } from "react";
import { UserGrantsContext } from "../contexts/userGrantsContext";

export const useUserGrantsContext = () => useContext(UserGrantsContext);
